
var i = 3
var siteT = ""
var racineT = ""
var dossierT = ""
if(i == 1) {
    siteT = '/api-maintenance3/public/index.php/'
    dossierT = '/api-maintenance2/'
    racineT = 'http://127.0.0.1'
}
else if(i == 2){
    siteT = '/api-maintenance/public/index.php/'
    dossierT = '/api-maintenance/'
    racineT = 'https://solubac.ddns.net:446'
}
else {
    siteT = '/api-maintenance/'
    dossierT = '/api-maintenance/'
    racineT = 'https://lingevres.ddns.net'
}
export const site = siteT
export const racine = racineT
export const dossier = dossierT

export const systemeClientId = "2"
export const systemeClient = site+"api/systeme_clients/"+systemeClientId